import React from 'react';
import { Route, Switch } from "react-router-dom";
import AdcuListingCalendarMain from './listing-calendar/listing-calendar-main';

const AdcuListingCalendar = () => {
  return (
    <Switch>
      <Route exact path="/listing-calendar">
        <AdcuListingCalendarMain />
      </Route>
    </Switch>
  )
}

export default AdcuListingCalendar;
